document.addEventListener("DOMContentLoaded", function () {
  const mobileMenuOpener = document.querySelector(
    ".header__nav .hamburger[data-mobile-menu-opener]"
  );

  const mobileMenuCloser = document.querySelector(".mobile-menu-closer");

  const copyOfMobileMenuCloser = mobileMenuCloser.cloneNode(true);

  const headerActions = document.querySelector(".header__actions");

  const copyOfHeaderActions = headerActions.innerHTML;

  if (mobileMenuOpener && headerActions) {
    mobileMenuOpener.addEventListener("click", function () {

      headerActions.innerHTML = "";
      headerActions.appendChild(copyOfMobileMenuCloser);
      mobileMenuCloser.style.display = "none";
      mobileMenuOpener.style.display = "none";
      mobileMenuOpener.classList.add("moved-out");

      copyOfMobileMenuCloser.addEventListener("click", function () {
        headerActions.innerHTML = copyOfHeaderActions;
        mobileMenuCloser.style.display = "none";
        mobileMenuOpener.removeAttribute("style");
        mobileMenuOpener.classList.remove("moved-out");
        const mobileMenuCloserButton = mobileMenuCloser.querySelector(
          "button[data-button-close]"
        );
        mobileMenuCloserButton.click();
      });
    });
  }
});

class ComplementaryVariantSelects extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', (event) => {
      const dropdownMenu = this.querySelector('.dropdown-menu');
      if (dropdownMenu && dropdownMenu.closest('#cart-modal')) {
        const distanceFromBottom = window.innerHeight - event.target.getBoundingClientRect().bottom + 40;
        dropdownMenu.style.bottom = `${distanceFromBottom}px`;
      }
    });

    this.addEventListener('change', (event) => {
      const quickAddButton = event.target.closest('.complementary-product').querySelector('quick-add-button');
      const price = event.target.closest('.complementary-product').querySelector('.price');
      quickAddButton.setAttribute('variant-id', event.target.dataset.variantId);
      if (event.target.dataset.comparePrice) {
        price.innerHTML = `<span class="sale-price order-2">${event.target.dataset.price}</span><s class="regular-price opacity-60">${event.target.dataset.comparePrice}</s>`;
      } else {
        price.innerHTML = `<span class="regular-price">${event.target.dataset.price}</span>`;
      }
    });
  }
}

customElements.define('complementary-variant-selects', ComplementaryVariantSelects);
